interface ReportDetailsProps {
    pagination: {
        pageNumber: number;
        totalPages: number;
        totalElements: number;
        pageSize: number;
    };
}

/**
 * ReportDetails Component
 *
 * Displays pagination summary information for reports.
 * Shows current page, total pages, total elements, and range of displayed elements.
 *
 * @param pagination - Pagination object containing page info
 */
export default function ReportDetails({ pagination }: ReportDetailsProps) {
    const hasPagination = Object.keys(pagination).length > 0;

    if (!hasPagination) {
        return null;
    }

    // Commented out - variables no longer needed after hiding pagination stats
    // const currentPage = pagination.pageNumber + 1;
    // const startElement = pagination.pageNumber * pagination.pageSize + 1;
    // const endElement = currentPage * pagination.pageSize;

    return (
        <div className="flex w-full flex-col">
            {/* Pagination statistics commented out - displayed at bottom instead */}
            {/* <span className="font-semibold">
                PAGINA:
                <span className="font-bold text-magenta"> {currentPage}</span>
            </span>
            <span className="font-semibold">
                TOTAL PAGINI:
                <span className="font-bold text-magenta"> {pagination.totalPages}</span>
            </span>
            <span className="font-semibold">
                TOTAL ELEMENTE:
                <span className="font-bold text-magenta"> {pagination.totalElements}</span>
            </span>
            <span className="font-semibold">
                ELEMENTE AFISATE:
                <span className="font-bold text-magenta">
                    {" "}
                    {startElement} - {endElement}
                </span>
            </span> */}
        </div>
    );
}
